import * as types from "./types";

export const setFeedbackGroup = ({ id, title }) => {
  return {
    type: types.SET_FEEDBACK_GROUP,
    payload: { id, title },
  };
};

export const setDate = date => {
  return {
    type: types.SET_DATE,
    payload: date,
  };
};

export const cacheFeedback = feedback => {
  return {
    type: types.CACHE_FEEDBACK,
    payload: feedback,
  };
};

export const loadFeedbacks = feedbacks => {
  return {
    type: types.LOAD_FEEDBACKS,
    payload: feedbacks,
  };
};

export const removeCachedFeedback = feedback => {
  return {
    type: types.REMOVE_CACHED_FEEDBACK,
    payload: feedback,
  };
};

export const updatePercentUploaded = percentUploaded => {
  return {
    type: types.UPDATE_PERCENT_UPLOADED,
    payload: percentUploaded,
  };
};

export const setFeedbackStatus = status => {
  return {
    type: types.SET_FEEDBACK_STATUS,
    payload: status,
  };
};

export const setFeedbackReview = review => {
  return {
    type: types.SET_FEEDBACK_REVIEW,
    payload: review,
  };
};

export const setIsReviewReceived = isReviewReceived => {
  return {
    type: types.SET_IS_REVIEW_RECEIVED,
    payload: isReviewReceived,
  };
};

export const setSelectedFeedbackOptions = selectedFeedbackOptions => {
  return {
    type: types.SET_SELECTED_FEEDBACK_OPTIONS,
    payload: selectedFeedbackOptions,
  };
};
